import { Box, CircularProgress, Typography } from '@mui/material';

interface MobileStepperProp {
    progress: number;
    totalSteps: number;
    currentPage?: string;
    nextPage?: string;
}

export default function MobileStepper({
    progress,
    totalSteps,
    currentPage,
    nextPage,
}: MobileStepperProp) {
    const percentageCompleted = ((progress + 1) / totalSteps) * 100;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '8px',
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    width: '64px',
                    height: '64px',
                }}
            >
                <CircularProgress
                    variant="determinate"
                    value={percentageCompleted}
                    size={64}
                    thickness={4}
                    sx={{ position: 'absolute', top: 0, left: 0 }}
                />
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '100%',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                    }}
                >
                    <Typography variant="body2" sx={{ color: 'white', fontWeight: 'bold' }}>
                        {`${progress + 1}/${totalSteps}`}
                    </Typography>
                </Box>
            </Box>
            <Box
                sx={{
                    textAlign: 'right',
                    flex: 1,
                    marginLeft: '16px',
                }}
            >
                <Typography sx={{ color: 'white', fontSize: '16px', fontWeight: 600 }}>
                    {currentPage}
                </Typography>
                <Typography sx={{ color: '#FFFFFF', fontSize: '12px', opacity: '75%' }}>
                    {progress !== totalSteps - 1 && <span>Next step: </span>}
                    {nextPage}
                </Typography>
            </Box>
        </Box>
    );
}
